import { UntypedFormGroup } from '@angular/forms';

/**
 * Cross field validators
 */
export const customPartsAgreementValidator = {
  /**
   * formCtrlOne >= formCtrlTwo not allowed
   */
  numberValidator: (formCtrlOne, formCtrlTwo) => (fg: UntypedFormGroup) => {
    const fieldOne = fg.controls[formCtrlOne];
    const fieldTwo = fg.controls[formCtrlTwo];
    if (fieldOne && fieldTwo && (fieldOne.value || fieldTwo.value)) {
      if (Number(fieldOne.value) > Number(fieldTwo.value)) {
        fieldOne.setErrors({ ...fieldOne.errors, number_mismatch: true });
        fieldTwo.setErrors({ ...fieldTwo.errors, number_mismatch: true });
      } else {
        let fieldOneError = { ...fieldOne.errors };
        delete fieldOneError.number_mismatch;
        fieldOneError = Object.keys(fieldOneError).length > 0 ? fieldOneError : null;
        fieldOne.setErrors(fieldOneError);
        let fieldTwoError = { ...fieldTwo.errors };
        delete fieldTwoError.number_mismatch;
        fieldTwoError = Object.keys(fieldTwoError).length > 0 ? fieldTwoError : null;
        fieldTwo.setErrors(fieldTwoError);
      }
    }
  },

  /**
   * formCtrlOne > formCtrlTwo not allowed
   */
  dateValidator: (formCtrlOne, formCtrlTwo) => (fg: UntypedFormGroup) => {
    const fieldOne = fg.controls[formCtrlOne];
    const fieldTwo = fg.controls[formCtrlTwo];
    if (fieldOne && fieldTwo && fieldOne.value && fieldTwo.value) {
      const fieldOneDate: Date = new Date(fieldOne.value);
      fieldOneDate.setHours(0, 0, 0, 0);
      const fieldTwoDate: Date = new Date(fieldTwo.value);
      fieldTwoDate.setHours(0, 0, 0, 0);
      if (fieldOneDate > fieldTwoDate) {
        fieldOne.setErrors({ ...fieldOne.errors, date_mismatch: true });
        fieldTwo.setErrors({ ...fieldTwo.errors, date_mismatch: true });
      } else {
        let fieldOneError = { ...fieldOne.errors };
        delete fieldOneError.date_mismatch;
        fieldOneError = Object.keys(fieldOneError).length > 0 ? fieldOneError : null;
        fieldOne.setErrors(fieldOneError);
        let fieldTwoError = { ...fieldTwo.errors };
        delete fieldTwoError.date_mismatch;
        fieldTwoError = Object.keys(fieldTwoError).length > 0 ? fieldTwoError : null;
        fieldTwo.setErrors(fieldTwoError);
      }
    }
  },
};
